import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionsSubject, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';

import { CheckOwner, CheckType } from 'src/app/shared/models/autogenerated';
import {
  selectAllPhases,
  selectMandatoryCheckTemplateForm,
} from '../../store/global-settings.selectors';
import {
  clearMandatoryCheckTemplateForm,
  createMandatoryCheckTemplateFromForm,
  createMandatoryCheckTemplateFromFormSuccess,
  loadAllPhases,
  loadMandatoryCheckTemplate,
  updateMandatoryCheckTemplateForm,
  updateMandatoryCheckTemplateFormSuccess,
} from '../../store/global-settings.actions';
import {
  CHECK_TYPE_MAX_LENGTH,
  DELIVERABLE_KEYWORDS_MAX_LENGTH,
  SCOPE_OF_REVIEW_MAX_LENGTH,
} from '../../../checks/checks.constants';

@Component({
  standalone: false,
  selector: 'app-mandatory-check-template-form-dialog',
  templateUrl: './mandatory-check-template-form-dialog.component.html',
  styleUrls: ['./mandatory-check-template-form-dialog.component.scss'],
})
export class MandatoryCheckTemplateDialogFormComponent implements OnDestroy {
  @Output() saved = new EventEmitter();
  formState$ = this.store.select(selectMandatoryCheckTemplateForm);
  allPhases$ = this.store.select(selectAllPhases);
  private readonly subscriptions = new Subscription();

  readonly CHECK_TYPES_VALUES = Object.values(CheckType);
  readonly CHECK_TYPES = CheckType;
  readonly CHECK_OWNER = CheckOwner;

  readonly SCOPE_OF_REVIEW_MAX_LENGTH = SCOPE_OF_REVIEW_MAX_LENGTH;
  readonly DELIVERABLE_KEYWORDS_MAX_LENGTH = DELIVERABLE_KEYWORDS_MAX_LENGTH;
  readonly CHECK_TYPE_MAX_LENGTH = CHECK_TYPE_MAX_LENGTH;

  readonly mandatoryCheckTemplateId?: string;
  readonly title: string;

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<MandatoryCheckTemplateDialogFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private actionsSubject$: ActionsSubject
  ) {
    this.store.dispatch(loadAllPhases());
    this.mandatoryCheckTemplateId = data;
    if (this.mandatoryCheckTemplateId) {
      this.store.dispatch(
        loadMandatoryCheckTemplate({
          mandatoryCheckTemplateId: this.mandatoryCheckTemplateId,
        })
      );
      this.title = 'edit mandatory check template';
    } else {
      this.store.dispatch(clearMandatoryCheckTemplateForm());
      this.title = 'add mandatory check template';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeWindow(): void {
    this.dialogRef.close();
  }

  save() {
    this.mandatoryCheckTemplateId ? this.update() : this.create();
  }

  private update() {
    this.registerActionSuccess(updateMandatoryCheckTemplateFormSuccess.type);
    this.store.dispatch(
      updateMandatoryCheckTemplateForm({
        mandatoryCheckTemplateId: this.mandatoryCheckTemplateId!,
      })
    );
  }

  private create() {
    this.registerActionSuccess(
      createMandatoryCheckTemplateFromFormSuccess.type
    );
    this.store.dispatch(createMandatoryCheckTemplateFromForm());
  }

  unsorted(a: any, b: any): number {
    return 0;
  }

  private registerActionSuccess(actionType: string) {
    this.subscriptions.add(
      this.actionsSubject$
        .pipe(filter((action) => action.type === actionType))
        .subscribe(() => {
          this.dialogRef.close();
        })
    );
  }
}
